const companyListing = function () {

    var CompanyActionListUi = function () {
        this.companyCheckboxes         = $('.companyToMailingListCheck');
        this.companyCheckboxesSelector = '.companyToMailingListCheck';
        this.contactCheckboxesSelector = '.contactToMailingListCheck';
        this.actionList                = $('#companyListSelectMailingList');
        this.applyCompaniesButton      = $('.companyListMailingApplyCompaniesButton');
        this.applyContactsButton       = $('.companyListMailingApplyContactsButton');
        this.emptyListButton           = $('.companyListMailingDeleteButton');
        this.companiesWithContacts     = {};
        this.selectMailingList     = $('.selectMailingList');

        this.hideCheckboxes();
    };

    /**
     * Registriert alle notwendigen Event-Handler.
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.initHandlers = function () {

        this.actionList.on('change',
                $.proxy(this.handleActionListChange, this));

        this.applyCompaniesButton.on('click',
                $.proxy(this.handleApplyCompaniesClick, this));

        this.emptyListButton.on('click',
                $.proxy(this.handleEmptyListClick, this));

        $(document).on('ifClicked', this.companyCheckboxesSelector,
                $.proxy(this.handleCompanyChange, this));

        $(document).on('ifClicked', this.contactCheckboxesSelector,
                $.proxy(this.handleContactChange, this));

        this.actionList.on('companyContactsLoaded',
                $.proxy(this.handleContactsLoaded, this));

        this.applyContactsButton.on('click',
                $.proxy(this.handleApplyContactsClick, this));

        if (this.selectMailingList.val() === '0') { // no action list is selected, so we have to hide the checkboxes
            this.hideCheckboxes();
        } else { // an action list is selected, so the checkboxes are visible and we have to trigger the selected option to get the associated data via ajax
            this.selectMailingList.change();
        }

        return this;
    };

    /**
     * Sets the active action list in the session.
     */
    CompanyActionListUi.prototype.setActiveActionListInSession = function () {
        $.ajax({
            url: '/company/action-list/set-active-action-list',
            data: {
                actionListId: $('.selectMailingList').val()
            },
            method: 'POST'
        });
    };

    /**
     * Handler fuer eine Aenderung der gewaehlten Aktionsliste.
     */
    CompanyActionListUi.prototype.handleActionListChange = function () {
        this.setActiveActionListInSession();

        if (!this.hasListSelected()) {
            this.hideCheckboxes();
        } else {
            this.getCompaniesAndContacts(function (data) {
                this.companiesWithContacts = data;
                this.uncheckAllCheckboxes()
                    .checkCheckboxes()
                    .showCheckboxes();
            }.bind(this));
        }
    };

    /**
     * Handler fuer das Uebernehmen der gefundenen Firmen auf die gewaehlte
     * Aktionsliste.
     */
    CompanyActionListUi.prototype.handleApplyCompaniesClick = function () {

        if (this.hasListSelected()) {
            this.applyCompanies();
        }
    };

    CompanyActionListUi.prototype.handleApplyContactsClick = function () {
        if (this.hasListSelected()) {
            this.applyContacts();
        }
    };

    /**
     * Handler fuer das Leeren der gewaehlten Aktionsliste.
     */
    CompanyActionListUi.prototype.handleEmptyListClick = function () {

        if (this.hasListSelected()) {
            this.emptyList();
        }
    };

    /**
     * Handler fuer die Aenderung einer Firmen-Auswahl.
     */
    CompanyActionListUi.prototype.handleCompanyChange = function (e) {
        var el   = $(e.currentTarget);
        var id   = el.val();

        if (!el.is(':checked')) {
            this.addCompany(id, function (success) {
                if (!success) {
                    el.prop('checked', false);
                }
            });
        } else {
            this.removeCompany(id, function (success) {
                if (!success) {
                    el.prop('checked', true);
                }
            });
        }
    };

    /**
     * Handler fuer die Aenderung einer Ansprechpartner-Auswahl.
     */
    CompanyActionListUi.prototype.handleContactChange = function (e) {

        var el        = $(e.currentTarget);
        var contactId = el.val();
        var companyId = el.parents('.companyListContacts')
                .attr('data-company-id');

        if (!el.is(':checked')) {

            this.addContact(companyId, contactId, function (success) {
                if (!success) {
                    el.prop('checked', false);
                }
            });
        } else {
            this.removeContact(companyId, contactId, function (success) {
                if (!success) {
                    el.prop('checked', true);
                }
            });
        }
    };

    /**
     * Handler fuer das vollstaendige Laden einer Liste mit Ansprechpartnern.
     */
    CompanyActionListUi.prototype.handleContactsLoaded = function () {
        this.uncheckAllCheckboxes()
                .checkCheckboxes();
    };

    /**
     * Deselektiert alle Checkboxen, die fuer die Aktionslisten relevant sind
     * (Firmen und Ansprechpartner).
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.uncheckAllCheckboxes = function () {
        this.companyCheckboxes.iCheck('uncheck');
        $(this.contactCheckboxesSelector).iCheck('uncheck');

        return this;
    };

    /**
     * Markiert die Checkboxen der in den uebergebenen Daten enthaltenen Firmen und
     * Ansprechpartner.
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.checkCheckboxes = function () {

        var self = this;

        this.companyCheckboxes.each(function (idx, el) {

            var companyId = el.value;
            var isCompanyOnList;
            var contactsOnList;

            if (!self.companiesWithContacts.hasOwnProperty(companyId)) {
                return;
            }

            isCompanyOnList = self.companiesWithContacts[companyId].isCompanyOnList;
            contactsOnList  = self.companiesWithContacts[companyId].contactsOnList;

            if (isCompanyOnList) {
                $(el).iCheck('check');
            }

            contactsOnList.forEach(function (contactId) {
                $('.companyListContacts')
                        .filter('[data-company-id="' + companyId + '"]')
                        .find(self.contactCheckboxesSelector)
                        .filter('[value="' + contactId + '"]')
                        .iCheck('check');
            });
        });

        return this;
    };

    /**
     * Holt die Firmen-IDs und dazugehoerige Ansprechpartner fuer die gewaehlte
     * Aktionsliste.
     *
     * @param {Function} cb Callback, wird mit dem Ergebnis als erstem Parameter
     *                      aufgerufen
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.getCompaniesAndContacts = function (cb) {

        var companyIds = this.companyCheckboxes.map(function (idx, el) {
            return this.value;
        }).get().join();

        if (companyIds !== '') {
            $.ajax({
                url: '/company/action-list/companies-with-contacts/' + this.actionList.val() + '/' + companyIds,
                method: 'GET',
                loadingOverlay: true
            }).done(function (data) {
                var blockLoader = new Esearcher.BlockLoader();
                blockLoader.process(data);
                if (data.success) {
                    cb(data.companiesWithContacts);
                } else {
                    cb([]);
                }
            });
        }

        return this;
    };

    /**
     * Eine Firma zur ausgewaehlten Aktionsliste hinzufuegen.
     *
     * @param {Number} companyId
     * @param {Function} cb Callback, wird mit Erfolgsstatus als Parameter
     *                      aufgerufen
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.addCompany = function (companyId, cb) {

        var self = this;

        $.post('/company/action-list/add-company/' + companyId, {
            listId: this.actionList.val()
        }, function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            cb(data.success);
            if (!self.companiesWithContacts.hasOwnProperty(companyId)) {
                self.companiesWithContacts[companyId] = {
                    isCompanyOnList: false,
                    contactsOnList: []
                };
            }
            self.companiesWithContacts[companyId].isCompanyOnList = true;
        });

        return this;
    };

    /**
     * Eine Firma von der ausgewaehlten Aktionsliste entfernen.
     *
     * @param {Number} companyId
     * @param {Function} cb Callback, wird mit Erfolgsstatus als Parameter
     *                      aufgerufen
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.removeCompany = function (companyId, cb) {

        var self = this;

        $.post('/company/action-list/remove-company/' + companyId, {
            listId: this.actionList.val()
        }, function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            cb(data.success);
            if (!self.companiesWithContacts.hasOwnProperty(companyId)) {
                self.companiesWithContacts[companyId] = {
                    isCompanyOnList: false,
                    contactsOnList: []
                };
            }
            self.companiesWithContacts[companyId].isCompanyOnList = false;
        });

        return this;
    };

    /**
     * Einen Ansprechpartner zur ausgewaehlten Aktionsliste hinzufuegen.
     *
     * @param {Number} companyId
     * @param {Number} contactId
     * @param {Function} cb Callback, wird mit Erfolgsstatus als Parameter
     *                      aufgerufen
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.addContact = function (companyId, contactId, cb) {
        var self = this;
        $.post('/company/action-list/add-contact/' + companyId, {
            listId: this.actionList.val(),
            contactId : contactId
        }, function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            cb(data.success);
            if (!self.companiesWithContacts.hasOwnProperty(companyId)) {
                self.companiesWithContacts[companyId] = {
                    isCompanyOnList: false,
                    contactsOnList: []
                };
            }
            self.companiesWithContacts[companyId].contactsOnList.push(contactId);
        });

        return this;
    };

    /**
     * Einen Ansprechpartner von der ausgewaehlten Aktionsliste entfernen.
     *
     * @param {Number} companyId
     * @param {Number} contactId
     * @param {Function} cb Callback, wird mit Erfolgsstatus als Parameter
     *                      aufgerufen
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.removeContact = function (companyId, contactId, cb) {
        var self = this;
        $.post('/company/action-list/remove-contact/' + companyId, {
            listId: this.actionList.val(),
            contactId : contactId
        }, function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            cb(data.success);
            if (self.companiesWithContacts.hasOwnProperty(companyId)) {
                var contacts = self.companiesWithContacts[companyId].contactsOnList;
                contacts.splice( $.inArray(contactId, contacts), 1 );
                self.companiesWithContacts[companyId].contactsOnList = contacts;
            }
        });

        return this;
    };

    /**
     * Alle gefundenen Firmen zur Aktionsliste hinzufuegen.
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.applyCompanies = function () {

        $.ajax({
            url: '/company/action-list/apply-all/' + this.actionList.val(),
            method: 'POST',
            loadingOverlay: true
        }).done($.proxy(function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            if (data.success) {
                var self = this;

                data.companyIds.forEach(function (id) {
                    if (!self.companiesWithContacts.hasOwnProperty(id)) {
                        self.companiesWithContacts[id] = {
                            isCompanyOnList: false,
                            contactsOnList: []
                        };
                    }
                    self.companiesWithContacts[id].isCompanyOnList = true;
                });

                this.checkCheckboxes();
            }
        }, this));

        return this;
    };

    CompanyActionListUi.prototype.applyContacts = function () {
        var self = this;

        $.post('/company/action-list/apply-all-contacts/' + this.actionList.val(),
            $.proxy(function (data) {
                var blockLoader = new Esearcher.BlockLoader();
                blockLoader.process(data);
                if (data.success) {
                    $(this.contactCheckboxesSelector).each(function(index) {
                        $(this).iCheck('check');
                    });
                }
            }, this));

        return this;
    };

    /**
     * Leert die ausgewaehlte Aktionsliste von allen Firmen und Ansprechpartnern.
     *
     * @returns {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.emptyList = function () {

        $.ajax({
            url: '/company/action-list/empty-all/' + this.actionList.val(),
            method: 'POST',
            loadingOverlay: true
        }).done($.proxy(function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            if (data.success) {
                this.companiesWithContacts = {};
                this.uncheckAllCheckboxes();
            }
        }, this));

        return this;
    };

    /**
     * Gibt zurueck, ob eine Aktionsliste ausgewaehlt wurde.
     *
     * @returns {Boolean}
     */
    CompanyActionListUi.prototype.hasListSelected = function () {
        return this.actionList.val() !== '0';
    };

    /**
     * Zeigt die Checkboxen vor den Firmen und Ansprechpartnern an.
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.showCheckboxes = function () {
        this.companyCheckboxes.each(function(i, e) {
            $(e).removeClass('no-ready');
            $(e).parent().show();
            $(e).parent().parent().show();
        });
        $(this.contactCheckboxesSelector).each(function(i, e) {
            $(e).removeClass('no-ready');
            $(e).parent().show();
            $(e).parent().parent().show();
        });

        parseCheckboxes();
        return this;
    };

    /**
     * Versteckt die Checkboxen vor Firmen und Ansprechpartnern.
     *
     * @return {CompanyActionListUi}
     */
    CompanyActionListUi.prototype.hideCheckboxes = function () {
        this.companyCheckboxes.each(function(i, e) {
            $(e).addClass('no-ready');
            if ($(e).parent().hasClass('checkbox-square')) {
                $(e).parent().hide();
            }
        });
        $(this.contactCheckboxesSelector).each(function(i, e) {
            $(e).addClass('no-ready');
            $(e).parent().hide();
        });

        parseCheckboxes();
        return this;
    };

    var companyActionList = new CompanyActionListUi();

    companyActionList.initHandlers();
};

export default companyListing;
